var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLock = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 7.16675V6.16675C5.83333 4.76662 5.83333 4.06655 6.10582 3.53177C6.3455 3.06137 6.72795 2.67892 7.19836 2.43923C7.73314 2.16675 8.4332 2.16675 9.83333 2.16675H10.1667C11.5668 2.16675 12.2669 2.16675 12.8016 2.43923C13.272 2.67892 13.6545 3.06137 13.8942 3.53177C14.1667 4.06655 14.1667 4.76662 14.1667 6.16675V7.16675M10 12.1667V13.8334M7.83333 18.8334H12.1667C14.0335 18.8334 14.9669 18.8334 15.68 18.4701C16.3072 18.1505 16.8171 17.6406 17.1367 17.0134C17.5 16.3003 17.5 15.3669 17.5 13.5001V12.5001C17.5 10.6332 17.5 9.69982 17.1367 8.98678C16.8171 8.35957 16.3072 7.84964 15.68 7.53006C14.9669 7.16675 14.0335 7.16675 12.1667 7.16675H7.83333C5.96649 7.16675 5.03307 7.16675 4.32003 7.53006C3.69282 7.84964 3.18289 8.35957 2.86331 8.98678C2.5 9.69982 2.5 10.6332 2.5 12.5001V13.5001C2.5 15.3669 2.5 16.3003 2.86331 17.0134C3.18289 17.6406 3.69282 18.1505 4.32003 18.4701C5.03307 18.8334 5.96649 18.8334 7.83333 18.8334Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
export default ForwardRef;